import { s } from '@/theme/tokens';
import { Box, type SxProps, type Theme } from '@/ui/primitives';
import { TABLE_CELL_TOP_PADDING, tableCellContentFlexSx } from './sharedCellContent';
import type { ReactElement, ReactNode } from 'react';

export type TableCellContainerGap = 'none' | 'sm' | 'md';
export type TableCellContainerPaddingTop = keyof typeof TABLE_CELL_TOP_PADDING;

type TableCellContainerProps = {
  children: ReactNode;
  gap: TableCellContainerGap;
  paddingTop?: TableCellContainerPaddingTop;
  sx?: SxProps<Theme>;
};

export const TableCellContainer = ({
  children,
  gap,
  paddingTop = 'standard',
  sx,
}: TableCellContainerProps): ReactElement => {
  return (
    <Box
      sx={
        [
          tableCellContentFlexSx,
          {
            display: 'flex',
            flexDirection: 'column',
            rowGap: s(gap),
          },
          { pt: TABLE_CELL_TOP_PADDING[paddingTop] },
          ...(sx ? (Array.isArray(sx) ? sx : [sx]) : []),
        ] satisfies SxProps<Theme>
      }
    >
      {children}
    </Box>
  );
};
